import script from "./CounterpartyInfoModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./CounterpartyInfoModal.vue?vue&type=script&setup=true&lang=ts"

import "./CounterpartyInfoModal.vue?vue&type=style&index=0&id=82560ba0&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-82560ba0"]])

export default __exports__